import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { DIALOG_CLOSE_BUTTON_SX } from "../../../constants/dialogCloseButtonStyles";
import { withoutBackdropClose } from "../../../utils/withoutBackdropClose";
import {
  AUTO_TAGGING_CONFIRM_CANCEL_BUTTON_SX,
  AUTO_TAGGING_CONFIRM_CONFIRM_BUTTON_SX,
  AUTO_TAGGING_CONFIRM_DIALOG_BODY_SX,
  AUTO_TAGGING_CONFIRM_DIALOG_PAPER_SX,
  AUTO_TAGGING_CONFIRM_DIALOG_TITLE_SX,
} from "../autoTaggingConfirmDialogStyles";

const DEFAULT_DELETE_DESCRIPTION =
  "This tagging plan will be deleted and will no longer be used for future auto-tagging. Existing tags generated by this plan will not be removed.";

type DeleteTaggingPlanConfirmDialogProps = Readonly<{
  open: boolean;
  deleting?: boolean;
  description?: string;
  onClose: () => void;
  onConfirm: () => void;
}>;

export default function DeleteTaggingPlanConfirmDialog({
  open,
  deleting = false,
  description = DEFAULT_DELETE_DESCRIPTION,
  onClose,
  onConfirm,
}: DeleteTaggingPlanConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={withoutBackdropClose(onClose)}
      maxWidth={false}
      PaperProps={{ sx: AUTO_TAGGING_CONFIRM_DIALOG_PAPER_SX }}
    >
      <DialogTitle sx={AUTO_TAGGING_CONFIRM_DIALOG_TITLE_SX}>
        Confirm Delete?
        <IconButton
          aria-label="Close"
          onClick={onClose}
          disabled={deleting}
          sx={DIALOG_CLOSE_BUTTON_SX}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, pb: 1 }}>
        <Typography sx={AUTO_TAGGING_CONFIRM_DIALOG_BODY_SX}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          variant="text"
          onClick={onClose}
          disabled={deleting}
          sx={AUTO_TAGGING_CONFIRM_CANCEL_BUTTON_SX}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={deleting}
          sx={AUTO_TAGGING_CONFIRM_CONFIRM_BUTTON_SX}
        >
          {deleting ? "Confirming…" : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
